export const NAVBAR_TRANSLATIONS_KEYS = [
  'home',
  'cameras',
  'minhas_cameras',
  'meus_videos',
  // 'resumo_diario',
  // 'detecao_de_movimentos',
  'lpr_menu',
  'facial',
  'crm_menu',
  'crm_menu_unavailable',
  // 'mosaico',
  // 'horus_two',
  // 'dashboard',
  // 'rede_colaborativa',
  'camera_registration',
  'cadastrar',
  'management',
  'compare',
  'analytics',
  'people_counting',
  'cameras_dashboard',
  'group_management',
  'group_person',
  'facial_notification_rules_menu',
  'face_not_identified_title',
  // 'face_low_quality_title',
  'integrations_menu',
  'security_forces_projects',
  'moni_integration',
  `lpr_dashboard`,
  'mosaic',
  'patrol',
  `lpr_dashboard_menu_title`,
  `lpr_blacklist_groups_menu_title`,
  `lpr_legacy_menu_title`,
  `horus`,
  'users_menu',
  'automation_menu',
  'devices_menu',
  'rules_engine_menu',
  'vehicle_counting',
];
